<div class="loading-overlay" *ngIf="show | async">
    <div class="loading-content">
      <div id="loading" class="loading-machin"></div>
      <div>Cargando...</div>
    </div>
</div>